import { useState, type FormEvent } from 'react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Spinner } from '@/components/ui/Spinner'
import { useAuthStore } from '@/lib/store/auth-store'

export function LoginForm() {
  const { login, isLoggingIn, loginError } = useAuthStore()
  const [homeserver, setHomeserver] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    login(homeserver, username, password)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <Input
        label="Homeserver"
        placeholder="matrix.example.com"
        value={homeserver}
        onChange={(e) => setHomeserver(e.target.value)}
        mono
        required
        disabled={isLoggingIn}
      />
      <Input
        label="Username"
        placeholder="@user:matrix.example.com"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
        disabled={isLoggingIn}
      />
      <Input
        label="Password"
        type="password"
        placeholder="••••••••"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        disabled={isLoggingIn}
      />

      {loginError && (
        <div className="border-l-2 border-l-[rgb(var(--np-status-critical))] bg-[rgb(var(--np-status-critical)/0.05)] px-4 py-3 rounded-r">
          <p className="text-sm text-[rgb(var(--np-status-critical))]">{loginError}</p>
        </div>
      )}

      <Button type="submit" disabled={isLoggingIn} className="w-full flex items-center justify-center gap-2">
        {isLoggingIn && <Spinner size={16} />}
        {isLoggingIn ? 'Connecting...' : 'Sign In'}
      </Button>
    </form>
  )
}
